import React from "react";
import "./App.css";
import Header from "./sections/Header";
import Hero from "./sections/Hero";
import Marquee from "./sections/Marquee";
import Services from "./sections/Services";
import WhyChoose from "./sections/WhyChoose";
import Stats from "./sections/Stats";
import Areas from "./sections/Areas";
import Testimonials from "./sections/Testimonials";
import FinalCTA from "./sections/FinalCTA";
import Footer from "./sections/Footer";
import FloatingButtons from "./sections/FloatingButtons";

function App() {
  return (
    <div className="App bg-black text-white min-h-screen" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <WhyChoose />
        <Stats />
        <Areas />
        <Testimonials />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}

export default App;
